/**
 * @file: clientPlatform.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { Platform } from 'react-native';

/**
 * The client the server gates the web version and the hub build by, sent
 * as `X-Client-Platform`. Best effort: the server falls back to the user
 * agent for builds that predate it. euler's only Android build is the
 * hub's (the phone app on Android is the separate gateway app).
 */
export function clientPlatform(): 'web' | 'tv' | 'ios' {
  switch (Platform.OS) {
    case 'web':
      return 'web';
    case 'android':
      return 'tv';
    default:
      return 'ios';
  }
}
